import { render, staticRenderFns } from "./ReviewThesis.vue?vue&type=template&id=0c3db5e8"
import script from "./ReviewThesis.vue?vue&type=script&lang=js"
export * from "./ReviewThesis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports